/** Usage periods are calendar months in UTC. `YYYY-MM`. */
export const PERIOD_RE = /^\d{4}-(0[1-9]|1[0-2])$/;

export const isPeriod = (v: string): boolean => PERIOD_RE.test(v);

export function currentPeriodUtc(now: Date = new Date()): string {
  return `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, '0')}`;
}

/** Midnight UTC on the first of the following month — when the ops counter resets. */
export function resetsAtUtc(period: string): string {
  const m = PERIOD_RE.exec(period);
  if (!m) throw new RangeError(`not a period: ${period}`);
  const [y, mo] = period.split('-').map(Number) as [number, number];
  const nextYear = mo === 12 ? y + 1 : y;
  const nextMonth = mo === 12 ? 1 : mo + 1;
  return `${nextYear}-${String(nextMonth).padStart(2, '0')}-01T00:00:00Z`;
}

/** Walk back from a period, for the period picker. */
export function previousPeriods(from: string, count: number): string[] {
  const [y0, m0] = from.split('-').map(Number) as [number, number];
  const out: string[] = [];
  let y = y0;
  let m = m0;
  for (let i = 0; i < count; i++) {
    out.push(`${y}-${String(m).padStart(2, '0')}`);
    m -= 1;
    if (m === 0) {
      m = 12;
      y -= 1;
    }
  }
  return out;
}
